import type { ScalarGuideElement } from '@/types'
import { attributesImageSchema, type AttributesImage } from './attributes'
import { validate } from '@/helpers/validate'
import { guideImageHtml } from '@/elements/image/component'
export type { AttributesImage } from './attributes'
export { ScalarImageVue } from './component'

export const scalarImage: ScalarGuideElement<AttributesImage, 'scalar-image'> =
  {
    name: 'scalar-image',
    tagName: 'scalar-image',
    tiptapName: 'custom_image',
    attributeTransform: (content, attrs) => {
      const validated = validate(attributesImageSchema, {
        ...attrs,
        caption: attrs.caption || content,
        ...((attrs.width || attrs.height) && { size: 'custom' }),
      })
      return validated
    },
    render: async (props) => {
      const transformed = scalarImage.attributeTransform('', props)
      return transformed ? guideImageHtml(transformed) : ''
    },
  }
